import { IconTaskMediumOutline, IconCalendarMediumOutline, IconProductsMediumOutline } from '@teamleader/ahoy';
import React, { ReactNode } from 'react';

import styles from './styles.css';
import { ProjectLine, ProjectLineType } from '../../../../../../Types/project';

export const ICON_MAP: Record<ProjectLineType, ReactNode> = {
  [ProjectLineType.Task]: <IconTaskMediumOutline className={styles['icon']} />,
  [ProjectLineType.Material]: <IconProductsMediumOutline className={styles['icon']} />,
  [ProjectLineType.Meeting]: <IconCalendarMediumOutline className={styles['icon']} />,
};

interface Props {
  line: ProjectLine;
}

const TitleCell = ({ line }: Props) => {
  return (
    <>
      {ICON_MAP[line.type]} {line.title}
    </>
  );
};

export default TitleCell;
